export default __webpack_public_path__ + "static/media/how-to-be-part.5500df45.png";